const language = {
  UNDEFINED: '未定義',

  AFRIKAANS: 'アフリカンス語',
  AMHARIC: 'アムハリア語',
  ARABIC: 'アラビア語',
  MODERN_STANDARD_ARABIC: '現代標準アラビア語',

  AZERBAIJANI: 'アゼルバイジャン語',
  BULGARIAN: 'ブルガリア語',
  BENGALI: 'ベンガル語',
  CATALAN: 'カタロニア語',
  CZECH: 'チェコ語',
  DANISH: 'デンマーク語',
  GERMAN: 'ドイツ語',
  GREEK: 'ギリシャ語',

  ENGLISH: '英語',
  AMERICAN_ENGLISH: '英語（アメリカ）',
  BRITISH_ENGLISH: '英語（イギリス）',

  SPANISH: 'スペイン語',
  EUROPEAN_SPANISH: 'スペイン語（ヨーロッパ）',
  LATIN_AMERICAN_SPANISH: 'スペイン語（ラテンアメリカ）',

  ESTONIAN: 'エストニア語',
  PERSIAN: 'ペルシア語',
  FINNISH: 'フィンランド語',
  FILIPINO: 'フィリピン語',
  FRENCH: 'フランス語',
  CANADIAN_FRENCH: 'フランス語（カナダ）',

  GUJARATI: 'グジャラティ語',
  HEBREW: 'ヘブライ語',
  HINDI: 'ヒンディー語',
  CROATIAN: 'クロアチア語',
  HUNGARIAN: 'ハンガリー語',
  ARMENIAN: 'アルメニア語',
  INDONESIAN: 'インドネシア語',
  ICELANDIC: 'アイスランド語',
  ITALIAN: 'イタリア語',
  JAPANESE: '日本語',
  GEORGIAN: 'グルジア語',
  KAZAKH: 'カザフ語',
  KHMER: 'クメール語',
  KANNADA: 'カンナダ語',
  KOREAN: '韓国語',
  KIRGHIZ: 'キルギス語',
  LAO: 'ラオス語',

  LITHUANIAN: 'リトアニア語',
  LATVIAN: 'ラトビア語',

  MACEDONIAN: 'マケドニア語',
  MALAYALAM: 'マラヤラム語',
  MONGOLIAN: 'モンゴル語',
  MARATHI: 'マラーティ語',
  MALAY: 'マレー語',
  BURMESE: 'ビルマ語',
  NEPALI: 'ネパール語',

  DUTCH: 'オランダ語',

  NORWEGIAN: 'ノルウェー語',

  PUNJABI: 'パンジャブ語',
  POLISH: 'ポーランド語',

  PORTUGUESE: 'ポルトガル語',
  BRAZILIAN_PORTUGUESE: 'ポルトガル語（ブラジル）',
  EUROPEAN_PORTUGUESE: 'ポルトガル語（ポルトガル）',

  ROMANIAN: 'ルーマニア語',
  RUSSIAN: 'ロシア語',
  SINHALA: 'シンハラ語',
  SLOVAK: 'スロバキア語',
  SLOVENIAN: 'スロベニア語',
  ALBANIAN: 'アルバニア語',
  SERBIAN: 'セルビア語',
  SERBIAN_LATIN: 'セルビア語（ラテン文字）',

  SWEDISH: 'スウェーデン語',
  SWAHILI: 'スワヒリ語',

  TAMIL: 'タミル語',
  TELUGU: 'テルグ語',
  THAI: 'タイ語',
  TURKISH: 'トルコ語',

  UKRAINIAN: 'ウクライナ語',
  URDU: 'ウルドゥ語',

  UZBEK: 'ウズベク語',
  VIETNAMESE: 'ベトナム語',
  CHINESE: '中国語',
  SIMPLIFIED_CHINESE: '中国語（簡体）',
  TRADITIONAL_CHINESE: '中国語（繁体字）',

  ZULU: 'ズールー語'
};

export default language;
